<template>
  <quiz-layout>
    <template #header>
      <h2 v-if="getUserDetail" class="text-capitalize">
        Welcome Back, {{ getUserDetail.name }}
      </h2>
    </template>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" to="/progress">
          <div class="item__icon">
            <svg viewBox="0 0 27 28" fill="none">
              <g clip-path="url(#clip0_79_12403)">
                <path
                  d="M13.5 0L0.5 9.88235V28H9.30645V17.2941H17.6935V28H26.5V9.88235L13.5 0Z"
                  fill="currentcolor"
                />
              </g>
              <defs>
                <clipPath id="clip0_79_12403">
                  <rect
                    width="26"
                    height="28"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="item__title">Home</div>
        </router-link>
        <router-link class="menu__item" to="/account">
          <div class="item__icon">
            <svg width="33" height="22" viewBox="0 0 33 22" fill="none">
              <g clip-path="url(#clip0_79_12397)">
                <path
                  d="M3.99323 15.9895C3.99528 16.2848 4.02507 16.5794 4.08191 16.8693C4.15452 17.2865 4.51673 17.5933 4.94409 17.5998H14.7225C15.1543 17.6077 15.5293 17.3069 15.6112 16.8871C15.671 16.5974 15.7037 16.3028 15.7091 16.007C15.6903 14.9848 15.3718 13.9899 14.7927 13.143C14.2135 12.2965 13.3986 11.6344 12.4469 11.2375C13.3204 10.505 13.8269 9.43139 13.8335 8.29815C13.8335 6.88356 13.071 5.57623 11.8335 4.86878C10.596 4.16133 9.07091 4.16133 7.83341 4.86878C6.59592 5.57623 5.8334 6.88356 5.8334 8.29815C5.83903 9.42958 6.34205 10.5027 7.21108 11.2375C6.27028 11.6397 5.46646 12.3018 4.89586 13.1447C4.32504 13.9874 4.01189 14.9751 3.99345 15.9895H3.99323Z"
                  fill="white"
                />
                <path
                  d="M31.611 7.03992C31.8467 7.03992 32.0729 6.94736 32.2396 6.7824C32.4063 6.61714 32.5 6.39349 32.5 6.16011V3.52011C32.5 2.58638 32.1253 1.69126 31.4586 1.03096C30.7916 0.370959 29.8875 0 28.9443 0H4.05569C3.11252 0 2.20836 0.370959 1.54138 1.03096C0.874708 1.69126 0.5 2.58638 0.5 3.52011V18.4799C0.5 19.4133 0.874708 20.3087 1.54138 20.969C2.20836 21.629 3.11252 22 4.05569 22H28.9443C29.8875 22 30.7916 21.629 31.4586 20.969C32.1253 20.3087 32.5 19.4133 32.5 18.4799V10.5599C32.5 10.074 32.1021 9.67977 31.611 9.67977C31.1203 9.67977 30.7223 10.074 30.7223 10.5599V18.4799C30.7223 18.9466 30.5348 19.3945 30.2015 19.7245C29.8681 20.0545 29.416 20.2398 28.9443 20.2398H4.05569C3.58399 20.2398 3.13187 20.0545 2.79854 19.7245C2.4652 19.3945 2.27769 18.9466 2.27769 18.4799V3.52011C2.27769 3.05313 2.4652 2.60554 2.79854 2.27553C3.13187 1.94553 3.58399 1.7599 4.05569 1.7599H28.9443C29.416 1.7599 29.8681 1.94553 30.2015 2.27553C30.5348 2.60554 30.7223 3.05313 30.7223 3.52011V6.16011C30.7223 6.39349 30.8158 6.61714 30.9824 6.7824C31.1494 6.94736 31.3753 7.03992 31.611 7.03992Z"
                  fill="white"
                />
                <path
                  d="M28.0559 5.28015H16.5C16.0092 5.28015 15.611 5.67412 15.611 6.16025C15.611 6.64609 16.0092 7.04005 16.5 7.04005H28.0559C28.5467 7.04005 28.9446 6.64609 28.9446 6.16025C28.9446 5.67412 28.5467 5.28015 28.0559 5.28015Z"
                  fill="white"
                />
                <path
                  d="M16.5 10.5602H24.5001C24.9908 10.5602 25.3891 10.1662 25.3891 9.68006C25.3891 9.19423 24.9908 8.80026 24.5001 8.80026H16.5C16.0092 8.80026 15.611 9.19423 15.611 9.68006C15.611 10.1662 16.0092 10.5602 16.5 10.5602Z"
                  fill="white"
                />
                <path
                  d="M17.3892 14.0804H28.0559C28.5467 14.0804 28.9446 13.6862 28.9446 13.2003C28.9446 12.7145 28.5467 12.3202 28.0559 12.3202H17.3892C16.8981 12.3202 16.5002 12.7145 16.5002 13.2003C16.5002 13.6862 16.8981 14.0804 17.3892 14.0804Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_79_12397">
                  <rect
                    width="32"
                    height="22"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="item__title">Account</div>
        </router-link>
        <router-link class="menu__item" to="/rewards">
          <div class="item__icon">
            <svg viewBox="0 0 31 30" fill="none">
              <g clip-path="url(#clip0_79_12395)">
                <path
                  d="M22.6428 27.1428C23.1065 27.7611 23.357 28.5129 23.357 29.2858C23.357 29.4751 23.2818 29.657 23.1478 29.7908C23.014 29.9248 22.8322 30 22.6428 30H8.35705C7.9624 30 7.64282 29.6804 7.64282 29.2858C7.64282 28.3386 8.01897 27.43 8.68887 26.7604C9.35852 26.0905 10.2671 25.7143 11.2143 25.7143C11.7825 25.7143 12.3276 25.4886 12.7295 25.0868C13.1313 24.6849 13.357 24.1398 13.357 23.5714V22.8143C13.5942 22.8432 13.8326 22.8576 14.0715 22.8571H16.9287C17.1716 22.8571 17.4287 22.8429 17.6429 22.8285V23.5714C17.6429 24.1398 17.8686 24.6849 18.2705 25.0868C18.6723 25.4886 19.2174 25.7143 19.7857 25.7143H15.1427C14.7483 25.7143 14.4285 26.0342 14.4285 26.4286C14.4285 26.8232 14.7484 27.1428 15.1427 27.1428H22.6428ZM30.5 9.28561V11.3429C30.5005 12.1378 30.2347 12.9099 29.7454 13.5364C29.2561 14.163 28.5713 14.6077 27.8 14.8L24.4787 15.6271C24.0614 17.1689 23.1833 18.5465 21.9615 19.5757C20.7398 20.6048 19.2331 21.2363 17.6429 21.3858C17.4057 21.4147 17.1674 21.4289 16.9284 21.4287H14.0712H14.0715C13.8326 21.4289 13.5942 21.4147 13.357 21.3858C11.7681 21.2366 10.2626 20.6058 9.04168 19.5782C7.82069 18.5503 6.94231 17.1744 6.52426 15.6343L3.20569 14.8057C2.43266 14.6127 1.74656 14.1667 1.25632 13.5387C0.766073 12.9106 0.499745 12.1369 0.5 11.3399V9.28561C0.5 8.89122 0.819644 8.57138 1.21423 8.57138H6.21412V6.42859C6.21412 6.03394 6.53402 5.71411 6.9286 5.71411H24.0715H24.0713C24.2609 5.71411 24.4424 5.78936 24.5765 5.92335C24.7106 6.05741 24.7858 6.23898 24.7858 6.42859V8.57132H9.78569C9.3913 8.57132 9.07146 8.89122 9.07146 9.28554C9.07146 9.68019 9.39136 10 9.78569 10H24.7858V13.5715C24.7858 13.7528 24.7472 13.9242 24.7344 14.1028L27.4486 13.4143C27.9122 13.3014 28.3245 13.0356 28.6191 12.6599C28.9135 12.284 29.0727 11.8201 29.0715 11.3428V10H24.7858V8.57132H29.7857C29.9751 8.57132 30.1569 8.64657 30.2907 8.78057C30.4247 8.91462 30.5 9.09626 30.5 9.28561ZM6.26393 14.0987C6.25245 13.9216 6.21386 13.7514 6.21386 13.5715V10.0001H1.92819V11.3401V11.3399C1.92794 11.8179 2.08763 12.2826 2.38158 12.6593C2.67577 13.0362 3.08732 13.304 3.55097 13.4201L6.26393 14.0987ZM17.8998 14.2857L16.2427 14.0428L15.4998 12.5428L14.7569 14.0428L13.0998 14.2857L14.2998 15.4571L14.0141 17.1001L15.4999 16.3285L16.9857 17.1001L16.6999 15.4571L17.8998 14.2857ZM25.5 21.4286C25.6893 21.4286 25.8712 21.3534 26.005 21.2194C26.139 21.0853 26.2142 20.9037 26.2142 20.7144V19.2857C26.2142 18.8913 25.8943 18.5715 25.5 18.5715C25.1053 18.5715 24.7858 18.8914 24.7858 19.2857V20.7144C24.7858 20.9037 24.861 21.0853 24.9947 21.2194C25.1288 21.3534 25.3104 21.4286 25.5 21.4286ZM25.5 22.8571C25.1053 22.8571 24.7858 23.177 24.7858 23.5713V25C24.7858 25.3944 25.1054 25.7142 25.5 25.7142C25.8944 25.7142 26.2142 25.3943 26.2142 25V23.5713C26.2142 23.3819 26.1389 23.2004 26.005 23.0663C25.8712 22.9323 25.6893 22.8571 25.5 22.8571ZM24.0715 21.4286H23.357C22.9627 21.4286 22.6428 21.7483 22.6428 22.1428C22.6428 22.5374 22.9627 22.8571 23.357 22.8571H24.0713C24.4659 22.8571 24.7858 22.5374 24.7858 22.1428C24.7858 21.7483 24.4659 21.4286 24.0713 21.4286H24.0715ZM27.6427 21.4286H26.9285C26.5341 21.4286 26.2143 21.7483 26.2143 22.1428C26.2143 22.5374 26.5342 22.8571 26.9285 22.8571H27.6427C28.0374 22.8571 28.3572 22.5374 28.3572 22.1428C28.3572 21.7483 28.0373 21.4286 27.6427 21.4286ZM4.07119 2.85715C4.26054 2.85715 4.44236 2.78189 4.57617 2.6479C4.71022 2.51384 4.78541 2.33228 4.78541 2.14267V0.714224C4.78541 0.319644 4.46558 0 4.07119 0C3.67654 0 3.35696 0.319644 3.35696 0.714224V2.14267C3.35696 2.33228 3.43222 2.51384 3.56596 2.6479C3.70001 2.78196 3.88165 2.85715 4.07119 2.85715ZM4.07119 4.2856C3.67654 4.2856 3.35696 4.60549 3.35696 4.99982V6.42852C3.35696 6.82291 3.67661 7.14275 4.07119 7.14275C4.46558 7.14275 4.78541 6.82285 4.78541 6.42852V4.99982C4.78541 4.81047 4.71016 4.62865 4.57617 4.49484C4.44236 4.36079 4.26054 4.2856 4.07119 4.2856ZM1.92819 4.2856H2.64242C3.03706 4.2856 3.3569 3.9657 3.3569 3.57137C3.3569 3.17673 3.037 2.85715 2.64242 2.85715H1.92819C1.53381 2.85715 1.21397 3.17679 1.21397 3.57137C1.21397 3.96576 1.53387 4.2856 1.92819 4.2856ZM5.49964 4.2856H6.21386C6.60851 4.2856 6.92834 3.9657 6.92834 3.57137C6.92834 3.17673 6.60844 2.85715 6.21386 2.85715H5.49964C5.10525 2.85715 4.78541 3.17679 4.78541 3.57137C4.78541 3.96576 5.10531 4.2856 5.49964 4.2856Z"
                  fill="currentcolor"
                />
              </g>
              <defs>
                <clipPath id="clip0_79_12395">
                  <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="item__title">Rewards</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__header">
        <div class="content__title">Quiz In Progress</div>
        <div class="content__summary">
          <div class="summary__item">
            In Progress
            <span class="summary__number">{{ inProgress.length }}</span>
          </div>
          <div class="summary__item">
            Completed
            <span class="summary__number">{{ completed.length }}</span>
          </div>
        </div>
        <div class="content__progressbar">
          <div class="content__progress" :style="computedProgress" />
        </div>
      </div>
      <div class="content__section">
        <div class="section__title">In Progress</div>
        <div class="content__group">
          <template v-if="inProgress.length === 0">
            <div class="group__item">
              <div class="group__title">
                You dont't have any quiz in progress.
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="group__item"
              v-for="(item, key) in inProgress"
              :key="key"
            >
              <div class="group__title">
                <a :href="`${appRedirectLink}/classroomcategory/${item.slug}`">
                  {{ item.name }}
                </a>
              </div>
              <router-link
                :to="`/quiz/${item.slug}`"
                class="d-flex align-items-center"
              >
                <div class="group__action">Continue</div>
              </router-link>
            </div>
          </template>
        </div>
      </div>
      <div class="content__section">
        <div class="section__title">Completed</div>
        <div class="content__group">
          <template v-if="completed.length === 0">
            <div class="group__item">
              <div class="group__title">You haven't completed any Quiz.</div>
            </div>
          </template>
          <template v-else>
            <div
              class="group__item"
              v-for="(item, key) in completed"
              :key="key"
            >
              <div class="group__title">{{ item.name }}</div>
              <div class="d-flex align-items-center">
                <div
                  class="group__action group__action--completed"
                  @click="getCertificate(item.slug)"
                >
                  View
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <b-modal
        id="viewCertificate"
        centered
        hide-header
        hide-footer
        @hidden="close"
        size="lg"
      >
        <img
          :src="`https://api.classroom.concinnitylimited.com/${selected.certificate}`"
          v-if="selected !== null"
          class="img-fit"
        />
      </b-modal>
    </template>
  </quiz-layout>
</template>
<script>
import { AccountService } from "../data/services/account.service";
import { CertificateService } from "../data/services/certificate.service";
import QuizLayout from "../layout/QuizLayout.vue";

const certificates = new Map();

export default {
  components: { QuizLayout },
  name: "Account",
  data() {
    return {
      inProgress: [],
      completed: [],
      appRedirectLink: process.env.VUE_APP_ROOT_LINK,
      certificates,
      selected: null,
    };
  },
  computed: {
    computedProgress() {
      const completedLength = this.completed.length;
      const inProgressLength = this.inProgress.length;

      let width = 0;
      if (completedLength !== 0 && inProgressLength !== 0) {
        width = (completedLength / inProgressLength) * 100;
      }

      return {
        width: `${width}px`,
      };
    },
    getUserDetail() {
      return this.$store.getters["auth/getUserDetailState"];
    },
  },
  mounted() {
    this.$store.dispatch("auth/getOwnProfile");
    this.getProgress();
  },
  methods: {
    // async getProfile () {
    //   const accountService = new AccountService();
    //   await accountService.getUserProfile().then(response => {
    //     console.log('response => ', response)
    //
    //   })
    // },
    async getProgress() {
      const accountService = new AccountService();
      const progressStatus = await accountService.getQuizProgress();
      progressStatus.forEach((progress) => {
        if (progress._id === "inprogress") {
          this.inProgress = progress.lessons.filter((lesson) => {
            return lesson.name !== undefined;
          });
          return;
        }
        if (progress._id === "completed") {
          this.completed = progress.lessons.filter((lesson) => {
            return lesson.name !== undefined;
          });
          return;
        }
      });
    },
    async getCertificate(slug) {
      if (this.certificates.has(slug) === true) {
        this.selected = this.certificates.get(slug);
        return this.$bvModal.show("viewCertificate");
      }

      const certificateService = new CertificateService();
      const certificate = await certificateService
        .getCertificate(slug)
        .catch((error) => {
          console.log({ error });
        });

      if (certificate !== undefined) {
        this.certificates.set(slug, certificate);
        this.selected = certificate;
        this.$bvModal.show("viewCertificate");
      }
    },
    close() {
      this.selected = null;
      this.$bvModal.hide("viewCertificate");
    },
  },
};
</script>
<style lang="scss" scoped>
$sidebar-width: 211px;
.page {
  width: 100%;
  display: flex;
  justify-content: center;

  .sidebar {
    &__menu {
      display: flex;
      flex-direction: column;
    }
  }

  .menu {
    &__item {
      display: flex;
      cursor: pointer;
      align-items: center;
      + .menu__item {
        margin-top: 20px;
      }
      &:hover {
        color: #f1bc04;
      }
    }
  }

  .item {
    &__icon {
      width: 26px;
      margin-right: 15px;
      svg {
        width: 100%;
      }
    }
    &__title {
      font-size: 20px;
      line-height: 24px;
    }
  }

  .content {
    &__title {
      font-weight: 500;
      font-size: 30px;
      line-height: 35px;
      margin-bottom: 30px;
    }
    &__summary {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 24px;
    }
    &__progressbar {
      border-radius: 20px;
      width: 100%;
      height: 7px;
      background: #d9d9d9;
      margin-bottom: 20px;
    }
    &__progress {
      height: 7px;
      width: 50%;
      background: #f1bc04;
      border-radius: 20px;
    }
    &__section {
      + .content__section {
        margin-top: 20px;
      }
    }

    &__group {
      padding: 20px;
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
    }
  }
  .summary {
    &__item {
      + .summary__item {
        margin-left: 10px;
      }
    }
  }

  .section {
    &__title {
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 22px;
      line-height: 24px;
      color: #000000;
    }
  }

  .group {
    &__item {
      display: flex;
      align-content: center;
      justify-content: space-between;
      + .group__item {
        margin-top: 10px;
      }
    }
    &__title {
      font-size: 16px;
      align-self: center;
      margin-right: 10px;
    }
    &__action {
      cursor: pointer;
      font-size: 14px;
      padding: 4px 15px;
      background: #024089;
      color: #ffffff;
      border-radius: 20px;
      &--completed {
        background: #f1bc04;
      }
    }
  }
}
</style>
